<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-col cols="2" class="pa-0">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">認証</span>
                </v-toolbar-title>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="4" class="pa-0">
                    <v-select
                      hideDetails
                      :items='schools'
                      label='塾'
                      v-model='school'
                      item-text="name"
                      item-value="key"
                    ></v-select>
                </v-col>
                <v-col cols="1" class="pa-0" align="end">
                  <!-- <v-btn dark rounded depressed small color="error" @click.native="onCreate()">
                    <span class="text-none">新規</span>
                  </v-btn> -->
                </v-col>
              </v-toolbar>
            </v-col>
          </v-row>
          <v-sheet color="transparent">
            <v-row class="ma-0 px-4 py-0" align="center">
              <v-col cols="12" class="pa-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <!-- <template v-for="(header, index) in headers"> -->
                    <v-col :cols="header.width"  :align="header.align" class="pa-0" v-for="(header, index) in headers" :key="header.key">
                      <template v-if="header.valid">
                        <v-sheet class="pa-0 customHeader" color="transparent">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </v-sheet>
                      </template>
                      <template v-else>
                        <span>{{ header.title }}</span>
                      </template>
                    </v-col>
                  <!-- </template> -->
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto' :style="contentsHeight">
                  <RecycleScroller
                    class="scroller"
                    :items="myAccounts"
                    :item-size="44"
                    key-field="uid"
                  >
                    <template v-slot="{ item, index }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                          <!-- <template v-for="(header) in headers"> -->
                            <v-col :cols="header.width" class="pa-0" :align="header.align" @click.stop="onEdit(item)" v-for="(header) in headers" :key="header.key">
                              <template v-if="header.key == 'number'">
                                <span class="overflow-text-hidden">{{ index + 1 }}</span>
                              </template>
                              <template v-if="header.key == 'displayName'">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="2" class="pa-0">
                                    <v-avatar size="30">
                                      <img v-if="item.photoURL" :src="item.photoURL">
                                    </v-avatar>
                                  </v-col>
                                  <v-col class="pa-0">
                                    <v-row class="ma-0">
                                    <span class="overflow-text-hidden caption">{{ item[header.key] }}</span>
                                    </v-row>
                                    <v-row justify="start" class="mx-2">
                                    <span class="overflow-text-hidden caption"><tt>{{ item['key'] }}</tt></span>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else-if="header.key == 'enableType'">
                                <v-chip x-small :color="item.disabled ? 'error' : 'primary'"><span >{{ item.disabled ? '無効' : '有効' }}</span></v-chip>
                              </template>
                              <template v-else>
                                <span class="overflow-text-hidden caption"><tt>{{ item[header.key] }}</tt></span>
                              </template>
                            </v-col>
                          <!-- </template> -->
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-col>

    <div class="text-center">
      <v-layout row justify-center align-center>
        <v-dialog
          v-model='loading'
          persistent
          width="60">
          <v-card>
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>

    <v-dialog
      v-model='dialog'
      persistent
      width="400">
      <app-account-dialog
        v-if='dialog'
        @dismissed="onDismissed"
        :item="item"
        :type="type">
      </app-account-dialog>
    </v-dialog>

  </v-row>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import moment from 'moment'
import { mapGetters } from 'vuex'
import AccountDialog from '../../components/admin/AccountDialog.vue'
Vue.component('app-account-dialog', AccountDialog)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      windowSize: 'shared/windowSize'
    }),
    myAccounts () {
      var temp = []
      for (var i in this.accounts) {
        var payload = JSON.parse(JSON.stringify(this.accounts[i]))
        if (this.school) {
          var index = this.users.findIndex(u => u.key === payload.uid)
          if (index !== -1) {
            if (!this.users[index].schools[this.school]) {
              continue
            }
          }
        }
        payload['createdAt'] = moment(payload.metadata.creationTime).format('YYYY-MM-DD')
        temp.push(payload)
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 48 - 2 - 40) + 'px;'
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      type: null,
      headers: [
        { valid: false, over: false, value: 0, title: '#', key: 'number', width: '1', align: 'center' },
        { valid: true, over: false, value: 0, title: 'uid', key: 'uid', width: '3', align: 'start' },
        { valid: true, over: false, value: 0, title: 'id', key: 'email', width: '3', align: 'start' },
        { valid: true, over: false, value: 0, title: '名称', key: 'displayName', width: '3', align: 'start' },
        { valid: true, over: false, value: 0, title: '作成日', key: 'createdAt', width: '1', align: 'start' },
        { valid: false, over: false, value: 0, title: '状態', key: 'enableType', width: '1', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      accounts: null,
      item: null,
      search: null,
      school: null
    }
  },
  created () {
    if (this.user) {
      this.getAccounts()
    }
    if (this.schools.length !== 0) {
      this.school = this.schools[0].key
    }
  },
  methods: {
    getAccounts () {
      var vm = this
      this.loading = true
      this.accounts = []
      var url = this.$FUNCTIONS_URL + '/user/all'
      firebase.auth().currentUser.getIdToken().then(function (token) {
        axios.get(url, {
          headers: { 'Authorization': `Bearer ${token}` }
        }).then(function (response) {
          vm.accounts = response.data.users
          vm.loading = false
        }).catch(function (error) {
          if (error) {
            // console.log(error)
          }
          vm.loading = false
        })
      })
    },
    checkAccount (item) {
      const index = this.users.findIndex(user => user.key === item.uid)
      return index !== -1
    },
    onDismissed: function (value) {
      if (value.update) {
        this.getAccounts()
      }
      this.dialog = false
    },
    onCreate () {
      this.type = 'add'
      this.item = null
      this.dialog = true
    },
    onEdit (item) {
      this.type = 'edit'
      this.item = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}
.customHeader {
  cursor: pointer;
  user-select: none;
}
.customLine {
  cursor: pointer;
  user-select: none;
}
.customLine:hover {
  background-color: #CCCCCC20;
}
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
